const intialState = {
  partner: {},
};

const partnerReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'partner/updatePartner':
      return {
        ...state,
        partner: action.payload,
      };
    case 'partner/getPartner':
      return state;
    default:
      return state;
  }
};

export default partnerReducer;
